export default __webpack_public_path__ + "static/media/warning-icon.f816b27a.svg";